const name = 'Overall Summary Report';

export const INITIALIZE = `[${name}] Initialize`;
export const DESTROY = `[${name}] Destroy`;
export const UPDATE_QUERY = `[${name}] Update Query`;
export const REPORT_LOADED = `[${name}] Report Loaded`;